import React, {useEffect, useState} from "react";
import { getUserActivities } from "../../service";
import useUserInfo from "../../routers/useUserInfo";
import FixedTabs from "../../components/fixed-tabs";
import bg from '../../images/logo-bg.png'
import {ActivitiesData} from "../types";
import {CouponItem} from "../../components/coupon";
import usePagination from "../../routers/usePagination";
import Pagination from "../../components/pagination";
import {dateFormat} from "../../units";

function MineActive() {

    const userData = useUserInfo()
    const [lists,setLists] = useState<Array<ActivitiesData>>([])
    const [active,setActive] = useState<number>(0)
    const { pageRef,noMore,reset } = usePagination();
    const [pageNum,setPage] = useState<number>(1);


    useEffect(() =>{
       if(userData){
           getUserActivities({
               userId:userData.id,
               pageNum,
               status:active
           }).then(res => {
               const lists = res.data.list
               if((lists as Array<ActivitiesData>).length > 0){
                   setLists(list => list.concat(lists))
               }else{
                   noMore()
               }
           })
       }
    },[pageNum,active])

    const TabChange = (index:number) => {
        setActive(index)
        setLists([])
        setPage(1)
        reset()
    }

    return <div className="user-active">
        <FixedTabs tabs={['待开始','进行中','已结束']} onChange={ TabChange }/>
        <div className="lists">
            {
                lists.map((item,index) => {
                    return <div className="item" key={index}>
                        <div className="img-box">
                            <div className="text" style={{ backgroundImage:`url(${ bg })` }}>
                                <h3>
                                    { item.activityTitle }
                                </h3>
                                <p className="date">有效期：{ dateFormat(item.startTime) } ~ { dateFormat(item.endTime) }</p>
                            </div>
                        </div>
                        <div className="b">
                            <div className="l">{ item.threshold }</div>
                            {/*<p className="iconfont">&#xe608;</p>*/}
                        </div>
                    </div>
                })
            }
        </div>
        <Pagination ref={pageRef} length={lists.length}  onChange={ (n) => setPage(n) }/>
    </div>
}

export default MineActive;
